// Breakpoint-Media-Queries wie in @ionic/core; lokal gehalten, um den Deep-Import
// in Ionics dist/collection-Interna zu vermeiden
const SIZE_TO_MEDIA: Record<string, string> = {
  xs: '(min-width: 0px)',
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
};

export class ToggleMenuHelper {
  /**
   * Show or hide the side-menu
   */
  public toggleMenu(): void {
    const splitPane = document.querySelector('ion-split-pane');
    if (!splitPane) return;
    const when = String(splitPane.when);
    if (window.matchMedia(SIZE_TO_MEDIA[when] || when).matches) {
      splitPane.classList.toggle('split-pane-visible');
    }
  }
}
